/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Filter } from "../../commons/types/Filter";
import { FilterField } from "../../commons/types/FilterField";
import { SearchValue } from "../../commons/types/SearchValue";
import { SearchField } from "../../commons/types/SearchField";
import { SheetId } from "../../commons/types/SheetId";
import { RecordId } from "../../commons/types/RecordId";
export const DeleteRecordsJobConfig = core.serialization.object({
    filter: Filter.optional(),
    filterField: FilterField.optional(),
    searchValue: SearchValue.optional(),
    searchField: SearchField.optional(),
    q: core.serialization.string().optional(),
    sheet: SheetId,
    exceptions: core.serialization.list(RecordId).optional(),
    snapshotLabel: core.serialization.string().optional(),
});
